<template>
  <div>
    <div class="title">
      {{ $t('invoice_flow__kuna__title_text', { currency: data.crypto_currency }) }}
    </div>

    <div class="qr-block">
      <div class="qr-wrapper"><QrcodeVue :value="data.address" level="H" size="250" /></div>
    </div>

    <div class="address_container">
      <div class="address">
        <span>{{ data.address }}</span>
        <svg class="js9dqtf_" viewBox="0 0 16 16" @click="onClick">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.69 0H14.7c.72 0 1.3.58 1.3 1.3v10.04c0 .72-.58 1.3-1.3 1.3h-.79V11.4h.72c.07 0 .12-.05.12-.12v-9.9a.13.13 0 0 0-.12-.12H4.76a.12.12 0 0 0-.12.12v.68H3.39V1.3C3.4.58 3.97 0 4.7 0zm-3.4 3.36h10.02c.72 0 1.3.58 1.3 1.3V14.7c0 .72-.58 1.3-1.3 1.3H1.3A1.3 1.3 0 0 1 0 14.7V4.66c0-.72.58-1.3 1.3-1.3zm.08 11.4h9.87c.07 0 .12-.06.12-.13v-9.9a.13.13 0 0 0-.12-.12H1.37a.13.13 0 0 0-.13.12v9.9c0 .07.06.12.13.12z"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import cloneDeep from 'lodash/cloneDeep';

export default {
  components: {
    QrcodeVue,
  },

  computed: {
    ...mapState(['flowData']),

    /*
     * @getter data
     * @returns {
     *     amount: string Payment amount
     *     currency: string Payment currency
     *     crypto_currency: string Paymnent crypto currency
     *     address: string For qr-code generation
     *     sn: string Payment ID for support service
     *     blockchain: string ??
     *     memo: any[] ??
     *  } | {}
     * */
    data() {
      const { requisites } = cloneDeep(this.flowData.payload);

      let data = {
        address: null,
        crypto_currency: null,
      };

      if (requisites && typeof requisites === 'object') {
        Object.keys(data).forEach(key => {
          if (key in requisites) {
            data[key] = requisites[key];
          }
        });
      }

      Object.keys(data).forEach(key => {
        if (!data[key]) delete data[key];
      });

      return data;
    },
  },

  methods: {
    onClick() {
      this.$copyText(this.data.address);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 35px;
}

.address_container {
  display: flex;
  justify-content: center;
  margin-top: 35px;
}

.address {
  max-width: 480px;
  min-height: 48px;
  padding: 15px 40px 15px 15px;
  border-radius: 2px;
  background-color: #f5f7f8;
  position: relative;
  margin: 0;

  @media screen and (max-width: 576px) {
    width: 100%;
  }

  span {
    display: block;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  svg {
    top: 16px;
    right: 16px;
    width: 16px;
    height: 16px;
    position: absolute;
    cursor: pointer;
    transition: fill 0.4s;
  }
}
</style>
